
export function ResourcesSection() {
  const buyerResources = [
    {
      icon: 'ri-calculator-line',
      title: 'Mortgage Calculator',
      description: 'Calculate your monthly payments and see what you can afford.',
      link: '/mortgage-calculator'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'First-Time Buyer Guide',
      description: 'Complete guide to MSHDA, VA, and FHA loan programs.',
      link: '/first-time-buyer-guide'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Neighborhood Guide',
      description: 'Explore Wayne, Oakland, and Macomb County communities.',
      link: '/neighborhood-guide'
    },
    {
      icon: 'ri-search-line',
      title: 'Property Search',
      description: 'Browse current listings and save your favorites.',
      link: '/property-search'
    }
  ];

  const sellerResources = [
    {
      icon: 'ri-line-chart-line',
      title: 'Home Valuation',
      description: 'Get an instant estimate of your home\'s current market value.',
      link: '/home-valuation'
    },
    {
      icon: 'ri-camera-line',
      title: 'Staging Tips',
      description: 'Professional tips to prepare your home for sale.',
      link: '/staging-tips'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Selling Timeline',
      description: 'Step-by-step guide to the home selling process.',
      link: '/selling-timeline'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Market Reports',
      description: 'Latest market trends and pricing data for your area.',
      link: '/market-reports'
    }
  ];

  const marketInsights = [
    {
      title: 'Metro Detroit Market Update - Q3 2025 & 2026 Outlook',
      date: 'October 15, 2025',
      excerpt: 'Q3 results show strong 5.8% price appreciation with 22% inventory increase. 2026 projections indicate continued growth with 3.5%-4.8% appreciation expected...',
      image: 'https://public.readdy.ai/ai/img_res/3e1508d27f53bd817e777cb5f0367558.jpg',
      link: '/market-insights/metro-detroit-forecast-2025'
    },
    {
      title: 'Interest Rate Update: Q3 2025 Results & 2026 Forecast',
      date: 'October 10, 2025',
      excerpt: 'Current rates at 6.2%-6.8% with projected decline to 5.8%-6.5% in 2026. Strategic timing recommendations for buyers and refinancing surge analysis...',
      image: 'https://readdy.ai/api/search-image?query=Interest%20rate%20trends%20analysis%202025%2C%20financial%20charts%20and%20graphs%2C%20professional%20real%20estate%20market%20data%20visualization%2C%20modern%20business%20setting&width=400&height=250&seq=market-2&orientation=landscape',
      link: '/market-insights/interest-rate-trends-2025'
    },
    {
      title: 'New Construction Update: Q3 2025 Results & 2026 Pipeline',
      date: 'October 5, 2025',
      excerpt: 'Q3 deliveries reached 4,850 new homes worth $1.9 billion. 2026 pipeline includes 22,000+ planned homes with focus on sustainability and smart technology...',
      image: 'https://readdy.ai/api/search-image?query=New%20construction%20development%20in%20Metro%20Detroit%2C%20modern%20homes%20being%20built%2C%20construction%20site%20with%20professional%20real%20estate%20photography%2C%20sustainable%20community%20planning&width=400&height=250&seq=market-3&orientation=landscape',
      link: '/market-insights/new-construction-boom-2025'
    }
  ];

  return (
    <section id="resources" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-white mb-4">
            Buyer & Seller Resources
          </h3>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Empowering you with the knowledge and tools needed to make informed real estate decisions. Education is the foundation of successful transactions.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h4 className="text-2xl font-bold text-white mb-8 flex items-center">
              <i className="ri-home-heart-line text-yellow-500 mr-3"></i>
              For Buyers
            </h4>
            <div className="space-y-6">
              {buyerResources.map((resource, index) => (
                <div key={index} className="flex items-start space-x-4 p-4 bg-white border-2 border-yellow-500 rounded-lg hover:border-yellow-400 transition-colors">
                  <div className="w-12 h-12 bg-black rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${resource.icon} text-xl text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <h5 className="font-bold text-black mb-2">{resource.title}</h5>
                    <p className="text-black text-sm mb-3">{resource.description}</p>
                    <a 
                      href={resource.link}
                      className="text-yellow-600 hover:text-yellow-700 font-medium text-sm cursor-pointer"
                    >
                      Learn More <i className="ri-arrow-right-line ml-1"></i>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div>
            <h4 className="text-2xl font-bold text-white mb-8 flex items-center">
              <i className="ri-building-line text-yellow-500 mr-3"></i>
              For Sellers
            </h4>
            <div className="space-y-6">
              {sellerResources.map((resource, index) => (
                <div key={index} className="flex items-start space-x-4 p-4 bg-white border-2 border-yellow-500 rounded-lg hover:border-yellow-400 transition-colors">
                  <div className="w-12 h-12 bg-black rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${resource.icon} text-xl text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <h5 className="font-bold text-black mb-2">{resource.title}</h5>
                    <p className="text-black text-sm mb-3">{resource.description}</p>
                    <a 
                      href={resource.link}
                      className="text-yellow-600 hover:text-yellow-700 font-medium text-sm cursor-pointer"
                    >
                      Get Started <i className="ri-arrow-right-line ml-1"></i>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="bg-black border-2 border-white rounded-lg p-8">
          <h4 className="text-2xl font-bold text-white mb-8 text-center">
            Market Insights & Updates
          </h4>
          <div className="grid md:grid-cols-3 gap-8">
            {marketInsights.map((insight, index) => (
              <article key={index} className="bg-white border-2 border-yellow-500 rounded-lg overflow-hidden hover:border-yellow-400 transition-all duration-300">
                <img 
                  src={insight.image}
                  alt={insight.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="text-sm text-gray-500 mb-2">{insight.date}</div>
                  <h5 className="font-bold text-black mb-3 leading-tight">{insight.title}</h5>
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">{insight.excerpt}</p>
                  <a 
                    href={insight.link}
                    className="text-yellow-600 hover:text-yellow-700 font-medium text-sm cursor-pointer"
                  >
                    Read Full Article <i className="ri-arrow-right-line ml-1"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
        
        <div className="text-center mt-12">
          <div className="bg-black border-2 border-white text-white rounded-lg overflow-hidden max-w-4xl mx-auto">
            <div className="p-8">
              <h4 className="text-2xl font-bold mb-4">Ready to Get Started?</h4>
              <p className="text-gray-300 mb-6">
                Whether you're buying, selling, or investing, I'm here to guide you through every step of your real estate journey.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                <button 
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-yellow-500 text-black px-8 py-3 rounded-lg hover:bg-yellow-400 transition-colors font-semibold cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-calendar-line mr-2"></i>
                  Schedule Consultation
                </button>
                <button className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-black transition-colors font-semibold cursor-pointer whitespace-nowrap">
                  <i className="ri-phone-line mr-2"></i>
                  Call Now: (248) 248-4801
                </button>
              </div>
              <div className="flex justify-center">
                <img 
                  src="https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/b313b8d643dd032252ddddc325e13ab3.png"
                  alt="Shantonya Scott - Ready to Help"
                  className="w-64 h-64 object-cover object-top rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </section>
  );
}
